import React from "react"
import type { OverlayRenderProps } from "react-photo-view/dist/types"
import { Button } from "@/components/ui/button"
import {
  MinusIcon,
  PlusIcon,
  RotateCounterClockwiseIcon,
} from "@radix-ui/react-icons"

export const ImageTopToolbar = ({
  rotate,
  onRotate,
  onScale,
  scale,
}: OverlayRenderProps) => {
  return (
    <div
      className="bottom-2 right-2 flex flex-row gap-2 bg-transparent"
      data-testid="image-top-toolbar"
    >
      <Button size="icon" variant="ghost" onClick={() => onScale(scale + 0.5)}>
        <PlusIcon className="h-4 w-4" />
      </Button>
      <Button size="icon" variant="ghost" onClick={() => onScale(scale - 0.5)}>
        <MinusIcon className="h-4 w-4" />
      </Button>
      <Button size="icon" variant="ghost" onClick={() => onRotate(rotate + 90)}>
        <RotateCounterClockwiseIcon className="h-4 w-4" />
      </Button>
    </div>
  )
}

export default React.memo(ImageTopToolbar)
